// Bibliotecas
import React from 'react';
import cn from 'classnames';

import Weight from './Weight/Weight'; // Componentes

// IMG
import EggIcon from './../../img/egg-icon.svg';
import PlusIcon from './../../img/plus-icon.svg';

import './Product.css'; // CSS

function Product({id, name, weights, showPlus, cursorPointer, onClick, children}) {
    const node = React.createRef();
    const weightsClass = weights.length > 2 ? "product__weights--between" : "product__weights--left";

    function handleClick(node){
        if(onClick) onClick(id, node.current);
    }
    
    return (
        <div className={cn("product", {"cursor-pointer": cursorPointer})} onClick={() => handleClick(node)} ref={node}>
            <div className="product__inner">
                <div className="product__egg">
                    <img src={EggIcon} />
                </div>
                
                <div className="product__right">
                    <div className="product__header">
                        <span className="product__name">{name}</span>
                    </div>

                    <div className="product__line"></div>

                    <div className={`product__weights ${weightsClass}`}>
                        {weights.map(weight => (
                            <Weight
                                id={weight.id}
                                price={weight.price}
                                weight={weight.value}
                                key={weight.id} />
                        ))}
                    </div>
                </div>

                {showPlus? (
                    <div className="product__plus">
                        <img src={PlusIcon} />
                    </div>
                ) : ""}
            </div>

            {children}
        </div>
    );
}

export default Product;